<template>
  <div class="binds-list-item-fake-button" :disabled="disabled">
    <binds-list-item-content :binds-disabled="isDisabled">
      <slot />
    </binds-list-item-content>
  </div>
</template>

<script>
import BindsListItemMixin from './BindsListItemMixin'

export default {
  name: 'BindsListItemFakeButton',
  mixins: [BindsListItemMixin]
}
</script>
